import { gql } from "apollo-boost";
import { AmazonIdeaFragment, AmazonIdeaTemplateFragment, AmazonIdeaTimelineFragment } from "../fragments/amazon-idea";

export const GET_AMAZON_IDEAS = gql`
  query getAmazonIdeas($filter: AmazonIdeaFilter!) {
    getAmazonIdeas(filter: $filter) {
      total
      aggregations
      nodes {
        ...AmazonIdeaFragment
      }
    }
  }
  ${AmazonIdeaFragment}
`;

export const GET_AMAZON_IDEA = gql`
    query getAmazonIdea($id: ID!) {
        getAmazonIdea(id: $id) {
            ...AmazonIdeaFragment
        }
    }
    ${AmazonIdeaFragment}
`;

export const GET_AMAZON_IDEA_TEMPLATES = gql`
    query getAmazonIdeaTemplates($filter: AmazonIdeaTemplateFilter!) {
    getAmazonIdeaTemplates(filter: $filter) {
      total
      nodes {
        ...AmazonIdeaTemplateFragment
      }
    }
  }
  ${AmazonIdeaTemplateFragment}
`;

export const GET_AMAZON_IDEA_TEMPLATE = gql`
    query getAmazonIdeaTemplate($id: ID!) {
        getAmazonIdeaTemplate(id: $id) {
            ...AmazonIdeaTemplateFragment
        }
    }
    ${AmazonIdeaTemplateFragment}
`;

export const GET_AMAZON_IDEA_TYPE = gql`
    query getAmazonIdeaType($filter: AmazonIdeaTypeFilter!) {
        getAmazonIdeaType(filter: $filter) 
    }
`;

export const GET_AMAZON_IDEA_TIMELINES = gql`
    query getAmazonIdeaTimelines($filter: AmazonIdeaTimelineFilter!) {
        getAmazonIdeaTimelines(filter: $filter) {
            total
            nodes {
                ...AmazonIdeaTimelineFragment
            }
        }
    }
    ${AmazonIdeaTimelineFragment}
`;
